import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
import Cabecera from '@/components/Cabecera'
import Registro from '@/components/Registro'
import iniciarSesion from '@/components/iniciarSesion'
import InicioUsuario from '@/components/InicioUsuario'
import Trazabilidad from '@/components/Trazabilidad'
import Menu from '@/components/Menu'
import EditarPerfilUsuario from '@/components/EditarPerfilUsuario'
import Decomisos from '@/components/Decomisos'
import SalidaCarne from '@/components/SalidaCarne'
import RegistrarVehiculos from '@/components/RegistrarVehiculos'
import RegistrarPersonas from '@/components/RegistrarPersonas'
import VerificarGafete from '@/components/VerificarGafete'
import VerificarGafeteVehiculo from '@/components/VerificarGafeteVehiculo'
import RegistrarFlujoEntrada from '@/components/RegistrarFlujoEntrada'
import RegistrarFlujoQR from '@/components/RegistrarFlujoQR'
import ActualizarFoto from '@/components/ActualizarFoto'
import FacturaGuia from '@/components/FacturaGuia'
import FacturaGuiaQR from '@/components/FacturaGuiaQR'
import Prueba from '@/components/Prueba'
import TrazabilidadPorcinos from '@/components/TrazabilidadPorcinos'
import FacturaGuiaPorcinos from '@/components/FacturaGuiaPorcinos'
import SalidaCarnePorcino from '@/components/SalidaCarnePorcino'
import Resumen from '@/components/Resumen'
import Imagenes from '@/components/Imagenes'
import QRPesos from '@/components/QRPesos'
import RegistroBitacora from '@/components/RegistroBitacora'
import RevisarBitacora from '@/components/RevisarBitacora'
import RevisarTrazabilidad from '@/components/RevisarTrazabilidad'
import menuinicial from '@/components/menuinicial'
import FacturaGuiaPorcinosFOTO from '@/components/FacturaGuiaPorcinosFOTO'
import FacturaGuiaFOTO from '@/components/FacturaGuiaFOTO'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/Cabecera',
      name: 'Cabecera',
      component: Cabecera
    },
    {
      path: '/Registro',
      name: 'Registro',
      component: Registro
    },
    {
      path: '/iniciarSesion',
      name: 'iniciarSesion',
      component: iniciarSesion
    },
    {
      path: '/InicioUsuario',
      name: 'InicioUsuario',
      component: InicioUsuario
    },
    {
      path: '/Trazabilidad',
      name: 'Trazabilidad',
      component: Trazabilidad
    },
    {
      path: '/Menu',
      name: 'Menu',
      component: Menu
    }, 
    {
      path: '/EditarPerfilUsuario',
      name: 'EditarPerfilUsuario',
      component: EditarPerfilUsuario
    },
    {
      path: '/Decomisos',
      name: 'Decomisos',
      component: Decomisos
    },
    {
      path: '/SalidaCarne',
      name: 'SalidaCarne',
      component: SalidaCarne
    },
    {
      path: '/RegistrarVehiculos',
      name: 'RegistrarVehiculos',
      component: RegistrarVehiculos
    },
    {
      path: '/RegistrarPersonas',
      name: 'RegistrarPersonas',
      component: RegistrarPersonas
    },
    {
      path: '/VerificarGafete/:id',
      name: 'VerificarGafete',
      component: VerificarGafete
    },
    {
      path: '/VerificarGafeteVehiculo/:id',
      name: 'VerificarGafeteVehiculo',
      component: VerificarGafeteVehiculo
    },
    {
      path: '/RegistrarFlujoEntrada',
      name: 'RegistrarFlujoEntrada',
      component: RegistrarFlujoEntrada
    },
    {
      path: '/RegistrarFlujoQR/:id',
      name: 'RegistrarFlujoQR',
      component: RegistrarFlujoQR
    },
    {
      path: '/ActualizarFoto',
      name: 'ActualizarFoto',
      component: ActualizarFoto
    },
    {
      path: '/FacturaGuia',
      name: 'FacturaGuia',
      component: FacturaGuia
    },
    {
      path: '/FacturaGuiaQR',
      name: 'FacturaGuiaQR',
      component: FacturaGuiaQR
    },
    {
      path: '/Prueba',
      name: 'Prueba',
      component: Prueba
    },
    {
      path: '/TrazabilidadPorcinos',
      name: 'TrazabilidadPorcinos',
      component: TrazabilidadPorcinos
    },
    {
      path: '/FacturaGuiaPorcinos',
      name: 'FacturaGuiaPorcinos',
      component: FacturaGuiaPorcinos
    },
    {
      path: '/SalidaCarnePorcino',
      name: 'SalidaCarnePorcino',
      component: SalidaCarnePorcino
    },
    {
      path: '/Resumen',
      name: 'Resumen',
      component: Resumen
    },
    {
      path: '/Imagenes',
      name: 'Imagenes',
      component: Imagenes
    },
    {
      path: '/QRPesos',
      name: 'QRPesos',
      component: QRPesos
    },
    {
      path: '/RegistroBitacora',
      name: 'RegistroBitacora',
      component: RegistroBitacora
    },
    {
      path: '/RevisarBitacora',
      name: 'RevisarBitacora',
      component: RevisarBitacora
    },
    {
      path: '/RevisarTrazabilidad',
      name: 'RevisarTrazabilidad',
      component: RevisarTrazabilidad
    },
    {
      path: '/menuinicial',
      name: 'menuinicial',
      component: menuinicial
    },
    {
      path: '/FacturaGuiaFOTO',
      name: 'FacturaGuiaFOTO',
      component: FacturaGuiaFOTO
    },
    {
      path: '/FacturaGuiaPorcinosFOTO',
      name: 'FacturaGuiaPorcinosFOTO',
      component: FacturaGuiaPorcinosFOTO
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js